import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function RequireAuth({ children }) {
  const { email, ready } = useAuth();
  const loc = useLocation();

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)]">
        <div className="font-mono text-xs uppercase tracking-widest text-[var(--text-muted)]">
          Chargement…
        </div>
      </div>
    );
  }
  if (!email) return <Navigate to="/login" replace state={{ from: loc }} />;
  return children;
}
